import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { preloadCriticalRoutes, preloadAdjacentRoutes } from '@/lib/route-preloader-enhanced';

export const RoutePreloader = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();

  // Preload critical routes on mount
  useEffect(() => {
    preloadCriticalRoutes();
  }, []);

  // Preload adjacent routes when location changes
  useEffect(() => {
    preloadAdjacentRoutes(location.pathname);
  }, [location.pathname]);

  return <>{children}</>;
};
